export default function KPICard({ label, value, subtitle, status, statusLabel }) {
  // status: 'ok' | 'warn' | 'danger' | null
  const statusColors = {
    ok: 'bg-deep-teal/10 text-deep-teal',
    warn: 'bg-soft-coral/20 text-rose',
    danger: 'bg-rose/10 text-rose',
  };

  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-5 flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-deep-teal">
          {label}
        </span>
        {status && statusLabel && (
          <span className={`text-[9px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-[3px] ${statusColors[status] || ''}`}>
            {statusLabel}
          </span>
        )}
      </div>
      <span className="text-[36px] font-bold text-navy leading-tight">
        {value}
      </span>
      {subtitle && (
        <span className="text-[12px] font-light text-[#888]">{subtitle}</span>
      )}
    </div>
  );
}
